import { muteFSAbortError } from "@excalidraw/common";

import { exportCanvas, prepareElementsForExport } from "../data";

import { useApp } from "./App";
import { IconButton } from "./IconButton";
import { save } from "./icons";

export const EstudaSaveButton = ({
  isMobile = false,
}: {
  isMobile?: boolean;
}) => {
  const app = useApp();

  const exportToParent = async () => {
    const { exportedElements, exportingFrame } = prepareElementsForExport(
      app.scene.getElementsIncludingDeleted(),
      app.state,
      false,
    );

    const blob = await exportCanvas(
      "svg",
      exportedElements,
      { ...app.state, exportEmbedScene: true },
      app.files,
      {
        exportBackground: app.state.exportBackground,
        name: app.state.name || undefined,
        viewBackgroundColor: app.state.viewBackgroundColor,
        exportingFrame,
      },
      false,
    )
      .catch(muteFSAbortError)
      .catch((error) => {
        console.error(error);
      });

    if (blob) {
      app.ownerWindow.parent.postMessage(
        {
          TYPE: "EXCALIDRAW_EXPORT_BLOB",
          source: blob,
        },
        "*",
      );
    }
  };

  return (
    <IconButton
      type="button"
      icon={save}
      label={isMobile ? undefined : "Salvar"}
      title="Salvar"
      aria-label="Salvar"
      onClick={exportToParent}
    />
  );
};
